import React, {useCallback, useEffect, useState} from 'react'
import {Col, VertIcon, VertLoading, VertSearch, VertTypography} from "@vertem-core/vertice-ds";
import {onlyNumbers} from "Utils/onlyNumbers";
import {ExclamationCircleOutlined} from "@ant-design/icons";
import {pointsMask} from "Utils/commons/points";
import {formatDateToBRString} from "Utils/format";
import {useDispatch, useSelector} from "react-redux";
import {resetShipping, setErrorMessage} from "../../../redux/Reducers/Shipping/ShippingSlice";
import {getShipping} from "../../../redux/Reducers/Shipping/ShippingApi";
import {useParams} from "react-router-dom";
import ynToBool from 'Utils/ynToBool';

const ProductDetailFreight = ({
  isQuoteItem
}) => {
    const { sku } = useParams()
    const [cepOfProduct, setCepOfProduct] = useState(null);
    const replacementCEPIfParticipantHasNoCEP =
        sessionStorage.getItem('replacementCep');

    const [address, setAddress] = useState(null);
    const [isEditingAddress, setIsEditingAddress] = useState(false);

    const Catalog = useSelector(({Catalog: data}) => data);
    const Participant = useSelector(({ Participants: data }) => data);
    const {
        isLoading: isLoadingShipping,
        error: errorOnShippingData,
        data: shippingData,
    } = useSelector(({ ShippingSlice: data }) => data);

    const {
        currencyConfiguration: { decimalPlaces, pointsName },
    } = Catalog;

    const dispatch = useDispatch()

    const clearAddressHandler = () => {
        setIsEditingAddress(true);
        setAddress(null);
        dispatch(resetShipping());
    };

    const checkIfUserAddressIsValid = useCallback(() => {
        let response = true;
        if (!Participant.address || !Participant.address.zipCode.value) {
            response = false;
        }

        return response;
    }, [Participant]);

    const zipcodeClickHandler = useCallback(
        (event) => {
            dispatch(resetShipping());
            const { value } = event.currentTarget;
            if (!isLoadingShipping) {
                setAddress(null);
                setCepOfProduct(value.replace('-', ''));
            }
            sessionStorage.setItem('replacementCep', value.replace('-', ''));
        },
        [isLoadingShipping]
    );

    if (!Catalog || !sku || !Participant) return null;

    const deliveryAvailable = (address && address.isDeliveryAvailable) || null;
    const isFreeDelivery = (address && address.points_value === 0) || false;

    useEffect(() => {
        if (
            Participant &&
            Participant.address &&
            checkIfUserAddressIsValid() &&
            !Participant.isLoading &&
            !isEditingAddress
        ) {
            const { addressText, district, number, city, state, zipCode } =
                Participant.address;

            setAddress({
                street: (addressText && addressText.value) || '',
                bourgh: (district && district.value) || '',
                number: (number && number.value) || 0,
                city: (city && city.value) || '',
                state: (state && state.value) || '',
                uf: (state && state.value) || '',
                cep: (zipCode && zipCode.value) || '',
            });
            setCepOfProduct((zipCode && zipCode.value) || '');
            !zipCode.value && dispatch(setErrorMessage('Endereço não cadastrado!'));
        }
    }, [
        Participant,
        Participant.address,
        Participant.address.zipCode,
        checkIfUserAddressIsValid,
    ]);

    useEffect(() => {
        if (shippingData && shippingData.address) {
            setAddress({
                ...address,
                street: shippingData.address,
                bourgh: shippingData.district,
                city: shippingData.city.split('-')[0].trim(),
                uf: shippingData.city.split('-')[1].trim(),
                state: shippingData.city.split('-')[1].trim(),
                points_value: shippingData.shippingValue,
                delivery_forecast: shippingData.deliveryForeCastDate,
                isDeliveryAvailable: true,
            });
        }
    }, [
        shippingData,
        shippingData?.address,
        shippingData?.city,
        shippingData?.district,
        shippingData?.shippingValue,
        shippingData?.deliveryForeCastDate,
    ]);

    useEffect(() => {
        if (
            !isQuoteItem &&
            (replacementCEPIfParticipantHasNoCEP || cepOfProduct) &&
            sku &&
            !sku.toUpperCase().includes('-PGS')
        ) {
            if (
                cepOfProduct === '00000000' ||
                replacementCEPIfParticipantHasNoCEP === '00000000'
            ) {
                clearAddressHandler();
                setCepOfProduct(null);
                sessionStorage.removeItem('replacementCep');
                return;
            }
            dispatch(
                getShipping({
                    productSku: sku,
                    participantCep: replacementCEPIfParticipantHasNoCEP || cepOfProduct,
                })
            );
        }
        return () => {
            dispatch(resetShipping());
        };
    }, [replacementCEPIfParticipantHasNoCEP, cepOfProduct, sku]);

    useEffect(() => {
        if (!isEditingAddress && !checkIfUserAddressIsValid()) {
            setIsEditingAddress(true);
        }
    }, [checkIfUserAddressIsValid, isEditingAddress]);


    

    return (
        <>
            <div className="shipping-wrapper">
                <div className="shipping-header">
                    <VertTypography.Paragraph className="shipping-label"
                          style={{
                            display: ynToBool(process.env.REACT_APP_HIDE_FREIGHT) ? 'none' : ''
                          }}
                    
                    >
                        Frete e prazo de entrega
                    </VertTypography.Paragraph>

                    {!isEditingAddress && (
                        <VertTypography.Paragraph
                            className="change-address-link"
                            onClick={clearAddressHandler}
                            underline
                        >
                            Editar endereço
                        </VertTypography.Paragraph>
                    )}
                </div>

                {isEditingAddress && (
                    <>
                        <div className="shipping-input-wrapper">
                            <VertSearch
                                mask={[{mask: '00000-000'}]}
                                onButtonHandler={(value) => zipcodeClickHandler(value)}
                                onKeyPress={onlyNumbers}
                                placeholder="00000-000"
                                template="marketplace"
                                value={
                                    replacementCEPIfParticipantHasNoCEP || cepOfProduct
                                }
                            />
                            <VertTypography.Paragraph className="shipping-search-link">
                                <a
                                    href="https://buscacepinter.correios.com.br/app/endereco/index.php"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    Não sei meu CEP
                                </a>
                            </VertTypography.Paragraph>
                        </div>
                    </>
                )}

                {isLoadingShipping ? (
                    <div className="shipping-load">
                        <VertLoading type="spin" size="small"/>
                    </div>
                ) : (
                    <>
                        {!!errorOnShippingData ? (
                            <div className="shipping-info-wrapper">
                                <div className="delivery-unavailable">
                                    <VertIcon component={ExclamationCircleOutlined}/>
                                    <VertTypography.Paragraph>
                                        {errorOnShippingData}
                                    </VertTypography.Paragraph>
                                </div>
                            </div>
                        ) : (
                            <div className="shipping-info-wrapper">
                                {deliveryAvailable && (
                                    <>
                                        <div className="address-info">
                                            {address.street && address.street !== ' ' && (
                                                <VertTypography.Paragraph>
                                                    {address.street}, {address.number}
                                                </VertTypography.Paragraph>
                                            )}
                                            {address.bourgh && (
                                                <VertTypography.Paragraph>
                                                    {address.bourgh}
                                                </VertTypography.Paragraph>
                                            )}
                                            {address.city && (
                                                <VertTypography.Paragraph>
                                                    {address.city} - {address.uf}
                                                </VertTypography.Paragraph>
                                            )}
                                        </div>
                                        <div className="shipping-info">
                                        <Col>
                                        <VertTypography.Paragraph className="label">
                                            Frete:
                                        </VertTypography.Paragraph>
                                        <VertTypography.Paragraph>
                                            {!isFreeDelivery && ` ${
                                                pointsMask(
                                                    address?.points_value ||
                                                    (shippingData &&
                                                        shippingData?.shippingValue),
                                                    decimalPlaces,
                                                    pointsName
                                                ).value
                                                }
                                              ${' '}
                                              ${
                                                pointsMask(
                                                    address?.points_value ||
                                                    (shippingData &&
                                                        shippingData?.shippingValue),
                                                    decimalPlaces,
                                                    pointsName
                                                ).label
                                             }
                                          `}
                                            {isFreeDelivery && (
                                                <span className="free-delivery">Grátis</span>
                                            )}
                                        </VertTypography.Paragraph>
                                    </Col>
                                    <Col>
                                        <VertTypography.Paragraph className="label">
                                            Entregue até:
                                        </VertTypography.Paragraph>
                                        <VertTypography.Paragraph>
                                            {address.delivery_forecast ||
                                                (shippingData &&
                                                    shippingData.value &&
                                                    shippingData.value.vendors[0] &&
                                                    formatDateToBRString(
                                                        new Date(
                                                            shippingData.value.vendors[0].deliveryDate
                                                        )
                                                    )) ||
                                                ''}
                                        </VertTypography.Paragraph>
                                    </Col>
                                </div>
                            </>
                        )}
                </div>
            )}
        </>
    )}
    </div>
</>)
}

export default ProductDetailFreight;
